////import '@babel/polyfill/noConflict';
//import * as Vue from 'vue';
import { createApp } from 'vue';

import RelatedLinksWidgetVue from './related-links-widget.vue';
import _ from 'lodash';
import TooltipDirective from '../tooltip_vue';
import { waitForBootstrap } from '../../bootstrap-helpers';

import '../../../../css/components/related-links.less';

export class RelatedLinksWidget {
    constructor(el, options) {
        this.props = options;

        this.init(el);
    }

    init(el) {
        //var app = new Vue({
        //    render: h => h(RelatedLinksWidgetVue, { props: this.props })
        //}).$mount(el);
        const app = createApp(RelatedLinksWidgetVue, this.props);
        //_.forEach(options, (value, key) => app.provide(key, value));
        app.directive('tooltip', TooltipDirective);
        waitForBootstrap(() => app.mount(el));
    }
}